import { formatVisitCount, type SiteVisitDay } from '../../types/siteVisits';

const formatShortDate = (date: string): string => {
  const [, month, day] = date.split('-');
  return month && day ? `${Number(month)}/${Number(day)}` : date;
};

/** 차트 라이브러리 없는 일별 막대 — 조회수는 진한 막대, 방문자는 그 안쪽 연한 막대. */
export function VisitsBarChart({ days }: { days: SiteVisitDay[] }) {
  if (days.length === 0) {
    return <p className="py-10 text-center text-sm text-muted-foreground">기간 안에 집계된 방문이 없습니다.</p>;
  }
  const maxViews = Math.max(1, ...days.map((day) => day.views));
  // 모바일에서 90일을 다 라벨링하면 읽을 수 없다 — 8칸 안팎으로 간격을 띄운다.
  const labelEvery = Math.max(1, Math.ceil(days.length / 8));

  return (
    <div role="img" aria-label={`일별 조회수·방문자 막대 그래프, ${days.length}일`}>
      <div className="flex h-44 items-end gap-px sm:gap-0.5">
        {days.map((day) => {
          const viewsHeight = Math.round((day.views / maxViews) * 100);
          const uniquesHeight = Math.round((day.uniques / maxViews) * 100);
          return (
            <div
              key={day.date}
              className="group relative flex h-full flex-1 items-end"
              title={`${day.date} · 조회 ${formatVisitCount(day.views)} · 방문 ${formatVisitCount(day.uniques)}`}
              data-testid="site-visits-bar"
            >
              <div
                className="w-full rounded-t-sm bg-primary/35 transition-colors group-hover:bg-primary/50"
                style={{ height: `${viewsHeight}%`, minHeight: day.views > 0 ? 2 : 0 }}
              />
              <div
                className="absolute inset-x-0 bottom-0 rounded-t-sm bg-primary"
                style={{ height: `${uniquesHeight}%`, minHeight: day.uniques > 0 ? 2 : 0 }}
              />
            </div>
          );
        })}
      </div>
      <div className="mt-1 flex gap-px border-t pt-1 text-[10px] text-muted-foreground sm:gap-0.5">
        {days.map((day, index) => (
          <div key={day.date} className="flex-1 truncate text-center">
            {index % labelEvery === 0 || index === days.length - 1 ? formatShortDate(day.date) : ''}
          </div>
        ))}
      </div>
      <div className="mt-2 flex flex-wrap gap-4 text-xs text-muted-foreground">
        <span className="inline-flex items-center gap-1.5"><i className="inline-block h-2.5 w-2.5 rounded-sm bg-primary/35" aria-hidden />조회수</span>
        <span className="inline-flex items-center gap-1.5"><i className="inline-block h-2.5 w-2.5 rounded-sm bg-primary" aria-hidden />방문자</span>
      </div>
    </div>
  );
}
